<script setup>
import KeywordManagementTable from '@frontJs/components/tables/projectManagement/sea/KeywordManagementTable.vue';
import TenantReportKeywordManagementTable from '@frontJs/components/tables/projectManagement/sea/tenantReports/KeywordManagementTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Pilotage Search - SEA - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEA - Pilotage Search
    </PageTitle>

    <KeywordManagementTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                content: h(TenantReportKeywordManagementTable),
            },
        }"
    />
</template>
